<main id="main-container">
    
  <div id="presentation-box">
    <h2 class="h2-first-line">Reliable, efficient delivery</h2>
    <h2 class="h2-second-line">Powered by Technology</h2>
    <p class="p">Our Artificial Intelligence powered tools use millions of project data points 
      to ensure that your project is successful</p>
    
  </div>

  <div id="boxes-section">
    <div class="main-box" id="item-1">
      <div class="ribbon light-blue"></div>
      <div class="box-description">
        <h3 class="h3">Supervisor</h3>
        <p class="p">Monitors activity to identify project roadblocks</p>
        <img src="./assets/icon-supervisor.svg" alt="Supervisor icon" class="item-svg" />
      </div>
    </div>

    <div class="main-box" id="item-2">
      <div class="ribbon red"></div>
      <div class="box-description">
        <h3 class="h3">Team Builder</h3>
        <p class="p">Scans our talent network to create the optimal team for your project</p>
        <img src="./assets/icon-team-builder.svg" alt="Team Builder icon" class="item-svg" />
      </div>
    </div>
    
    <div class="main-box" id="item-3">
      <div class="ribbon orange"></div>
      <div class="box-description">
        <h3 class="h3">Karma</h3>
        <p class="p">Regularly evaluates our talent to ensure quality</p>
        <img src="./assets/icon-karma.svg" alt="Karma icon" class="item-svg" />
      </div>
    </div>

    <div class="main-box" id="item-4">
      <div class="ribbon dark-blue"></div>
      <div class="box-description">
        <h3 class="h3">Calculator</h3>
        <p class="p">Uses data from past projects to provide better delivery estimates</p>
        <img src="./assets/icon-calculator.svg" alt="Calculator icon" class="item-svg" />
      </div>  
    </div>
  </div>
</main>